import React from 'react'
import style2 from './button.module.scss'

import Icon from 'components/Icon/Icon'

interface IProps {
  title: string
  type?: 'green' | 'bule' | 'gray'
  loading?: boolean
  onClick?: (...args: any[]) => any,
  className?: string
  style?: object
}

function Button ({ type = 'bule', loading = false, onClick, title, className, style }: IProps) {
  const classN = style2[type] || ''
  style = style || {}

  function handleClick (...args) {
    // console.log(args)
    // console.log('click')
    // console.trace()
    if (loading) {
      return
    }
    onClick && onClick(...args)
  }

  return (
    <button
      style={style}
      className={style2.button + ' ' + className + ' ' + classN}
      onClick={handleClick}
    >
      {
        loading ? <Icon icon="iconloading" className={style2.loading} /> : null
      }
      {
        title
      }
    </button>
  )
}

export default Button
